/**
 * Extracts the hostname from a URL string, without its `www.` prefix.
 * Returns the original string if parsing fails.
 */
export function extractDomainFromUrl(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

/**
 * Builds a Google favicon URL for a given hostname. The host is encoded: some
 * callers fall back on a source's title when it has no URL. An `<img>` loading
 * it sets `referrerPolicy="no-referrer"`, or every logo hands Google the
 * conversation's URL.
 */
export function faviconUrl(hostname: string): string {
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(hostname)}&sz=16`;
}
